export interface PeopleListFilters {
  status?: string
  campusId?: string
  tagId?: string
  sort?: string
}

export const peopleKeys = {
  all: () => ['people'] as const,
  lists: () => [...peopleKeys.all(), 'list'] as const,
  list: (filters: PeopleListFilters) => [...peopleKeys.lists(), filters] as const,
  detail: (id: string) => [...peopleKeys.all(), 'detail', id] as const,
  search: (q: string) => [...peopleKeys.all(), 'search', q] as const,
}
